import type { ReactNode } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { getPublishedCategories } from "@/lib/cms-catalog";

/** Server layout shell — Navbar is a client island; page content stays server when possible. */
export async function PageShell({ children }: { children: ReactNode }) {
  const categories = await getPublishedCategories();
  return (
    <div className="min-h-screen bg-background">
      <Navbar categories={categories} />
      {children}
      <WhatsAppFloat />
      <Footer categories={categories} />
    </div>
  );
}
